import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { Router } from '@angular/router';
import { BlobUrls } from '@src/app/core/config';
import { BlobMetum } from '@src/app/core/models/model';

@Component({
  selector: 'app-video-player-modal',
  templateUrl: './video-player-modal.component.html',
  styleUrls: ['./video-player-modal.component.scss']
})
export class VideoPlayerModalComponent implements OnInit, AfterViewInit {
  blob: BlobMetum;
  constructor(public modalRef: MdbModalRef<VideoPlayerModalComponent>, public router: Router) { }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

    this.router.events.subscribe(() => {

      this.modalRef.close()

    });

  }

  getURL(blob: BlobMetum) {
    return encodeURI(BlobUrls.Download + '/' + blob.modifiedName);
  }

}